"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusItemExport = exports.clickSaveSVG = exports.Modale_resolution_png = exports.PlusLinkSabotColor = exports.PlusAssignLinkValueToCorrectVar = exports.PlusReturnValueLink = exports.OSPIsAllNodeNotLocalAttrSameValue = exports.IsAllZdtAttrSameValue = exports.SetSvgBg = exports.ImportImageAsSvgBg = exports.DragLegendPlus = exports.DefaultSankeyPlusStyleLink = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const fa_1 = require("react-icons/fa");
const d3 = __importStar(require("d3"));
const file_saver_1 = __importDefault(require("file-saver"));
const react_2 = require("@chakra-ui/react");
const SankeyPlusNodes_1 = require("./SankeyPlusNodes");
const OpenSankey_1 = require("./import/OpenSankey");
const SankeyMenuTop_1 = require("open-sankey/dist/topmenus/SankeyMenuTop");
const DefaultSankeyPlusStyleLink = () => {
    const style = (0, OpenSankey_1.DefaultLinkStyle)();
    style.gradient = false;
    return style;
};
exports.DefaultSankeyPlusStyleLink = DefaultSankeyPlusStyleLink;
const DragLegendPlus = (data, set_data, multi_selected_label, ComponentUpdater) => d3.drag()
    .subject(Object).on('drag', function (event) {
    if (d3.select('.opensankey #svg').nodes().length > 0) {
        (0, OpenSankey_1.DragLegendGElementOSTyped)(data, event);
        if (data.legend_position[0] === 0 || data.legend_position[1] === 0) {
            (0, SankeyPlusNodes_1.OpposingDragElementsPlus)([{ x: data.legend_position[0], y: data.legend_position[1] }], event, {}, data, { current: [] }, multi_selected_label);
        }
    }
}).on('end', () => ComponentUpdater.updateComponentMenuConfigLayout.current());
exports.DragLegendPlus = DragLegendPlus;
const ImportImageAsSvgBg = (t, data, set_data, has_open_sankey_plus) => {
    const _load_image = (0, react_1.useRef)(null);
    const content_image = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
            react_1.default.createElement(react_2.Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: data.show_background_image, isDisabled: !has_open_sankey_plus, icon: data.show_background_image ? react_1.default.createElement(fa_1.FaEye, null) : react_1.default.createElement(fa_1.FaEyeSlash, null), onChange: (evt) => {
                    data.show_background_image = evt.target.checked;
                    set_data(Object.assign({}, data));
                } }, t('MEP.show_image')),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'imageDisabled2', placement: 'top', delay: 500, overlay: (!has_open_sankey_plus) ?
                    react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'imageDisabled2' },
                        t('Menu.sankeyPlusDisabled'),
                        " ") :
                    react_1.default.createElement(react_1.default.Fragment, null) },
                react_1.default.createElement(react_2.Box, null,
                    react_1.default.createElement(react_2.Button, { variant: 'menuconfigpanel_option_button', isDisabled: !data.show_background_image || !has_open_sankey_plus, onClick: () => {
                            if (_load_image.current) {
                                _load_image.current.name = '';
                                _load_image.current.click();
                            }
                        } },
                        react_1.default.createElement(fa_1.FaFileImport, null)),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { ref: _load_image, style: { display: 'none' }, accept: 'image/*', type: "file", value: '', disabled: !has_open_sankey_plus, onChange: (evt) => {
                            const files = evt.target.files;
                            const reader = new FileReader();
                            reader.onload = (() => {
                                return (e) => {
                                    const resultat = e.target.result;
                                    const res = resultat === null || resultat === void 0 ? void 0 : resultat.toString().replaceAll('=', '');
                                    data.background_image = res;
                                    set_data(Object.assign({}, data));
                                };
                            })();
                            reader.readAsDataURL(files[0]);
                        } })))));
    return content_image;
};
exports.ImportImageAsSvgBg = ImportImageAsSvgBg;
const SetSvgBg = (data) => {
    d3.select('#svg')
        .filter(() => !data.show_background_image || data.background_image === undefined || data.background_image === '')
        .style('background-image', null)
        .style('background-size', 'contain')
        .style('background-repeat', 'no-repeat');
    d3.select('#svg')
        .filter(() => data.show_background_image && data.background_image !== undefined && data.background_image !== '')
        .style('background-image', 'url(' + data.background_image + ')')
        .style('background-size', 'contain')
        .style('background-repeat', 'no-repeat');
};
exports.SetSvgBg = SetSvgBg;
const IsAllZdtAttrSameValue = (data, m_s_zdt, k) => {
    if (m_s_zdt.length === 0) {
        return [null, null];
    }
    const first_value = m_s_zdt[0][k];
    let all_same = true;
    m_s_zdt.forEach(l => {
        all_same = l[k] !== first_value ? false : all_same;
    });
    return (all_same ? [first_value, false] : [0, true]);
};
exports.IsAllZdtAttrSameValue = IsAllZdtAttrSameValue;
// export const PlusIsAllNodeNotLocalAttrSameValue=(data:SankeyPlusData,m_s_n:SankeyPlusNode[],k_list:(keyof SankeyPlusNode)[])=>{
// return IsAllNodeNotLocalAttrSameValue(data,m_s_n,k_list)
// }
const OSPIsAllNodeNotLocalAttrSameValue = (data, m_s_n, k_list) => {
    // store_value : variable that contain an array forEach key we are looking for
    // Each array contain in first position the value of the selected nodes attribute
    // In second position it contain a boolean that return true if all selected nodes have the same value for the key
    const store_value = {};
    if (m_s_n.length > 0) {
        // For each selected nodes
        m_s_n.forEach((node, i) => {
            // For each attributes we want to check
            k_list.forEach(k => {
                // Get the value of the node attribute(k)
                const val = node[k];
                // Store first value of each node attribute
                if (i === 0) {
                    store_value[k] = [val, false];
                }
                else {
                    // Check if other nodes selected have the same value, if not we set the 2nd value of the array at true
                    store_value[k][1] = val !== store_value[k][0] ? true : store_value[k][1];
                }
            });
        });
    }
    else {
        k_list.forEach(k => {
            store_value[k] = [false, false];
        });
    }
    return store_value;
};
exports.OSPIsAllNodeNotLocalAttrSameValue = OSPIsAllNodeNotLocalAttrSameValue;
const PlusReturnValueLink = (data, l, k) => {
    return (0, OpenSankey_1.ReturnValueLink)(data, l, k);
};
exports.PlusReturnValueLink = PlusReturnValueLink;
const PlusAssignLinkValueToCorrectVar = (l, k, v, menu_for_style) => {
    return (0, OpenSankey_1.AssignLinkValueToCorrectVar)(l, k, v, menu_for_style);
};
exports.PlusAssignLinkValueToCorrectVar = PlusAssignLinkValueToCorrectVar;
const PlusLinkSabotColor = (l, data, GetLinkValue) => {
    return (0, exports.PlusReturnValueLink)(data, l, 'gradient') === true ? (0, OpenSankey_1.NodeColor)(data.nodes[l.idSource], data) : (0, OpenSankey_1.LinkColor)(l, data, GetLinkValue);
};
exports.PlusLinkSabotColor = PlusLinkSabotColor;
const Modale_resolution_png = (t, dict_hook_ref_setter_show_dialog_components) => {
    const [h, set_h] = (0, react_1.useState)();
    const [v, set_v] = (0, react_1.useState)();
    const show_dialog_resolution = (0, react_1.useState)(false);
    const valid_input = (h === undefined && v === undefined) || (v !== undefined && h !== undefined && !isNaN(+v) && !isNaN(+h));
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_resolution_save_png.current = show_dialog_resolution[1];
    return react_1.default.createElement(react_bootstrap_1.Modal, { size: 'sm', id: 'modale_choose_resolution_png', show: show_dialog_resolution[0], onHide: () => show_dialog_resolution[1](false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, t('Menu.setResolutionPNG')),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, t('Menu.larg')),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'number', value: h, step: 1, onChange: (evt) => {
                        if (evt.target.value === undefined || !isNaN(+evt.target.value)) {
                            set_h(evt.target.value);
                        }
                    } })),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, t('Menu.haut')),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'number', value: v, step: 1, onChange: (evt) => {
                        if (evt.target.value === undefined || !isNaN(+evt.target.value)) {
                            set_v(evt.target.value);
                        }
                    } }))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_2.Button, { variant: 'primary', disabled: !valid_input, onClick: () => clickSavePNG(h, v) }, "Save")));
};
exports.Modale_resolution_png = Modale_resolution_png;
const clickSavePNG = (h, v) => {
    const svg = (0, SankeyMenuTop_1.pre_process_export_svg)();
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('html', blob);
    let size_to_send = '';
    if (h !== undefined && v !== undefined) {
        size_to_send = h + ' ' + v;
    }
    form_data.append('size', size_to_send);
    (0, SankeyMenuTop_1.post_process_export_svg)();
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_png';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/png' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.png');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_png';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
// Function used before exporting a sankey to svg format
// It add used attribute from css file in the html tag attribute 'style', because otherwise the foreignObject element doesn't have proper css
const addStyleInlineSVG = () => {
    d3.selectAll('#svg foreignObject *:not(br)').nodes().forEach(el => {
        const elements_for_style = getComputedStyle(el);
        Object.values(elements_for_style).forEach(ks => {
            // Get css properties of the element in the navigator
            const val = elements_for_style.getPropertyValue(ks);
            if (val !== undefined && val !== '' && !ks.includes('webkit')) {
                // Add the css propertie in the attribute style so it is used in the svg file
                d3.select(el).style(ks, val);
            }
        });
    });
};
const clickSaveSVG = () => {
    const svg = (0, SankeyMenuTop_1.pre_process_export_svg)();
    addStyleInlineSVG();
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('html', blob);
    (0, SankeyMenuTop_1.post_process_export_svg)();
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_svg';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/svg' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.svg');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_svg';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
exports.clickSaveSVG = clickSaveSVG;
const PlusItemExport = (dict_hook_ref_setter_show_dialog_components) => {
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: exports.clickSaveSVG }, "SVG"),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => dict_hook_ref_setter_show_dialog_components.ref_setter_show_resolution_save_png.current(true) }, "PNG"));
};
exports.PlusItemExport = PlusItemExport;
